<template>
  <div class="contrato-container">
    <div class="header-section">
      <div class="logo-area logo-left">
        <img :src="logoSuape" alt="Logo SUAPE" class="img-fluid logo-img" />
      </div>
      <div class="title-center">
        DECLARAÇÃO DE VÍNCULO DE PROFISSIONAIS
      </div>
      <div class="logo-area logo-right">
        <img v-if="dados.logoFornecedorUrl" :src="dados.logoFornecedorUrl" alt="Logo Contratada" class="img-fluid logo-img" />
        <div v-else class="box-placeholder">
          Logomarca da empresa<br>(consórcio) contratada
        </div>
      </div>
    </div>

    <div class="texto-legal-container">
        <p>
            A <strong>{{ fornecedor.nome }}</strong> com sede em <strong>{{ enderecoCompleto }}</strong>,
            Inscrita no CNPJ nº <strong>{{ fornecedor.cpfCnpj | cnpj }}</strong>,
            detentora do contrato nº <strong>{{ dados.numeroContrato }}</strong>,
            em atendimento a Diretoria de Infraestrutura - DINFRA/SUAPE,
            <strong>Declara</strong> sob as penas cabíveis, que o pessoal técnico de nível médio e superior mobilizado para a
            execução dos serviços de <strong>"{{ dados.objeto }}"</strong>,
            exerceram as atividades Laborais,
            Referente ao período de <strong>{{ dados.periodo }}</strong>.
        </p>
    </div>

    <div class="content-slot mt-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import DadosCadastraisServicos from '@/app/fornecedor/dadoscadastrais/DadosCadastraisServicos'

export default {
  name: 'DeclaracaoVinculoHeader',
  props: {
    dados: { type: Object, required: true },
    logoSuape: { type: String, default: '/img/logo.png' },
    cnpjContratada: { type: String, required: true }
  },
  data () {
    return {
      fornecedor: {}
    }
  },
  async mounted () {
    if (this.cnpjContratada) {
      try {
        const cnpjLimpo = this.cnpjContratada.replace(/\D/g, '')
        const response = await DadosCadastraisServicos.obterDadosPorCpfCnpj(cnpjLimpo)
        if (response.success) {
          this.fornecedor = response.data
        }
      } catch (error) {
        console.error('Erro ao buscar dados do fornecedor pelo CNPJ:', error)
      }
    }
  },
  computed: {
    enderecoCompleto () {
      if (!this.fornecedor || !this.fornecedor.logradouro) return 'ENDEREÇO NÃO CADASTRADO'
      const { logradouro, numero, complemento, bairro, cidade, uf } = this.fornecedor
      let endereco = `${logradouro || ''}`
      if (numero) endereco += `, ${numero}`
      if (bairro) endereco += ` - ${bairro}`
      if (cidade) endereco += `, ${cidade}`
      if (uf) endereco += `/${uf}`
      return endereco
    }
  },
  filters: {
    currency(value) {
      if (value === null || value === undefined) return 'R$ 0,00'
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    cnpj(value) {
      if (!value) return ''
      value = value.replace(/\D/g, '') // Remove all non-digit characters
      if (value.length > 14) value = value.substring(0, 14) // Truncate if too long

      // Apply CNPJ mask: XX.XXX.XXX/XXXX-XX
      return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
    }
  }
}
</script>

<style scoped>
.contrato-container {
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  width: 100%;
  background: #fff;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin-bottom: 5px;
  min-height: 80px;
}

.logo-area { width: 20%; display: flex; align-items: center; }
.logo-left { justify-content: flex-start; }
.logo-right { justify-content: flex-end; }
.logo-img { max-width: 100%; max-height: 100px; object-fit: contain; }
.title-center { flex-grow: 1; text-align: center; font-weight: 600; font-size: 1.2rem; text-transform: uppercase; }
.box-placeholder { border: 1px solid #000; padding: 5px; font-weight: 500; text-align: center; font-size: 0.8rem; width: 100%; }


.texto-legal-container {
  width: 100%;
  margin-bottom: 15px;
  padding: 0 40px;
  box-sizing: border-box;
}

.texto-legal-container p {
  text-align: justify;
  line-height: 1.5;
  font-size: 0.85rem;
  margin: 0;
}
</style>
